module.exports = __webpack_public_path__ + "img/IMG-20190905-WA0005.944a57e7.jpg";